import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App.jsx'

// ── Sentry Error Monitoring ──
const dsn = import.meta.env.VITE_SENTRY_DSN;
if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE || 'production',
    release: 'smarttraq@1.3.2',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

// ── PWA Service Worker Registration ──
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(reg => {
        console.log('[SmartTraQ] SW registered, scope:', reg.scope);

        // Check for updates every 30 minutes
        setInterval(() => { reg.update().catch(() => {}); }, 30 * 60 * 1000);

        // Listen for new SW waiting
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New version available — dispatch custom event for App.jsx to show banner
              window.dispatchEvent(new CustomEvent('sw-update-available', { detail: { reg } }));
            }
          });
        });
      })
      .catch(err => console.warn('[SmartTraQ] SW registration failed:', err));
  });
}
